module.exports = __webpack_public_path__ + "static/12-8edc65a2c3210092b7c154eeab9e2872.jpg";